import api from '@/api'

export default {
    namespaced: true,
    state: {
        osk: null
    },
    mutations: {
        SET_KEY: (state, data) => {
            state.osk = data
        }
    },
    actions: {
        getOssKey({commit}) {
            api.getOssKey().then(res => {
                commit('SET_KEY', res)
            })
        }
    }
}
